import { configureStore } from '@reduxjs/toolkit';
import fileSlice from './files-slice';
import uiSlice from './ui-slice';
import reviewSlice from './review-slice';

const store = configureStore({
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredPaths: ['dataBlob']
			}
		}),
	reducer: {
		filesManager: fileSlice.reducer,
		ui: uiSlice.reducer,
		reviewsManager: reviewSlice.reducer
	}
});

export default store;
